<div class="section-container" [ngClass]="{ 'section-container-single': !isDrawerOpen }">
    <div class="middle-section-with-gamification-cards">
        <div class="middle-section-container">
            <app-myfavourite (onFavChnage)="onFavChnage($event)"  [parentcateName]="parentCatename" [promptlist]="promptlist" [allcategory]="allcategory"
                [selectedLibrary]="selectedLibrary"></app-myfavourite>
            <div class="card-container">
                <div class="breadcrumb"
                    *ngIf="(selectedLibrary != 'All Categories' && selectedLibrary != 'My Favourites' && selectedLibrary != 'My Prompts' && selectedLibrary != 'Approval Pending')">
                    <span style="color: var(--Full-Color-Set-Neutral-600, #5E5E72);
                                text-align: center;
                                font-family:'Lato', sans-serif;
                                font-size: 14px;
                                font-style: normal;
                                cursor: pointer;
                                font-weight: 400;
                                line-height: 20px; /* 142.857% */" (click)="breadcrumbclick('All Category')">All Categories</span>
                    <span
                        *ngIf="(selectedLibrary != 'All Categories' && selectedLibrary != 'My Favourites' && selectedLibrary != 'My Prompts' && selectedLibrary != 'Approval Pending')">
                        <img style="margin-bottom: -4px; margin-left: 2px;" src="/assets/icons/Arrowbredo.svg" alt="Arrowbredo">
                    </span>
                    <span style="color: var(--Core-Colors-Purple_Default, #503291);
                                text-align: center;
                                font-family: 'Lato', sans-serif;
                                font-size: 14px;
                                cursor: pointer;
                                font-style: normal;
                                font-weight: 700;
                                line-height: 20px;"
                                (click)="breadcrumbclick(selectedLibrary)" *ngIf="parentCate" > {{selectedLibrary}}</span>
                    
                                <span style="color: var(--Full-Color-Set-Neutral-600, #5E5E72);
                                text-align: center;
                                font-family: 'Lato', sans-serif;
                                font-size: 14px;
                                font-style: normal;
                                cursor: pointer;
                                font-weight: 400;
                                line-height: 20px; " (click)="breadcrumbclick(parentCatename,'parentCatename')" *ngIf="!parentCate">{{parentCatename}}</span>
                                <span *ngIf="!parentCate && selectedLibrary != 'All Category'"><img style="margin-bottom: -4px; margin-left: 2px;" src="/assets/icons/Arrowbredo.svg" alt="arrow icon"></span>
                                <span style="color: var(--Core-Colors-Purple_Default, #503291);
                                text-align: center;
                                font-family: 'Lato', sans-serif;
                                font-size: 14px;
                                cursor: pointer;
                                font-style: normal;
                                font-weight: 700;
                                line-height: 20px; "
                                (click)="breadcrumbclick(selectedLibrary)" *ngIf="!parentCate">{{selectedLibrary}}</span>
                </div>
                <div class="title-container">
                    <div class="title">
                        <h4>{{ selectedLibrary }} ({{ promptCount }})</h4> 
                       
                    </div>
                    <div>
                        <app-select-dropdown class="sort-by-dropdown" [options]="sortOptions"
                            (selectionChange)="onChange($event)" [selectedOption]="selectedValue"
                            [permanentLabel]="'Sort By:'"></app-select-dropdown>
                    </div>

                </div>
                <div #middleCard  class="middle-sction" id="middleCard"  (scroll)="scrollHandler($event)" >

                    <div class="promt-filter-wrapper">
                        <div class="filters">

                            <div class="category-filter filter-div mr-22"
                                *ngIf=" ( selectedLibrary === ''|| selectedLibrary === 'My Favourites' || selectedLibrary === 'Approval Pending' || selectedLibrary === 'My Prompts' || selectedLibrary === 'All Categories'  )">
                                <app-multi-select-dropdown [placeHolderTitle]="'Category'"
                                    [dropdownList]="dropDownCategories" [dropdownSettings]="categoryDropdownSettings" [selectedItems]="selectedCat"
                                    [clearfilter]=clearfilter
                                    (onSelectionChange)="onChangeCategory($event)"></app-multi-select-dropdown>
                            </div>

                            <div class="filter-div mr-22" *ngIf="selectedLibrary === 'My Prompts'">
                                <app-multi-select-dropdown [placeHolderTitle]="'Status'" [dropdownList]="Status" [selectedItems]="selectedStatus"
                                    [dropdownSettings]="statusDropdownSettings" [clearfilter]=clearfilter
                                    (onSelectionChange)="onChangeStatus($event)"></app-multi-select-dropdown>
                            </div>

                            <div class="filter-div mr-22"  *ngIf="selectedLibrary != 'My Prompts'">
                                <app-multi-select-dropdown [placeHolderTitle]="'Submitted by'" [selectedItems]="selectedCreatedBy" [clearfilter]=clearfilter
                                    [dropdownList]="dropdownCreators" [dropdownSettings]="creatorsDropdownSettings"
                                    (onSelectionChange)="onChangeCreatedby($event)"></app-multi-select-dropdown>
                            </div>
                           
                            <div class="clearalldiv">
                                <button for="clear all" class="clearAll" (click)="clearAllFilter()"> Clear All </button>
                            </div>
                        </div>

                    </div>
                    <div class="prompt-cards" *ngIf="!isLoading" [ngClass]="{'prompt-cards-when-drawer-open': isDrawerOpen}">

                        @if (!allPrompt?.length) {
                           <p>No search result found.</p> 
                        }
                        <div class="prompt-card" *ngFor="let prompt of allPrompt ; let i = index; trackBy: trackByIndex"
                            (click)="consumePrompt(prompt,i)"
                            [ngClass]="{'prompt-card-selected': selectedCardIndex === i}">
                            <div style="height: 29px;" *ngIf="selectedLibrary === 'All Categories' || selectedLibrary === 'My Favourites' || selectedLibrary === 'My Prompts' || selectedLibrary === 'Approval Pending'" class="breadcrumb-container padding-zero">
                                <div 
                                    style="display: flex; flex-direction: column; align-items: flex-start; justify-content: center; gap: 0.5rem;">
                                    <nav class="breadcrumb padding-zero" aria-labelledby="breadcrumb-heading">
                                        <ul
                                            *ngIf="selectedLibrary === 'All Categories' || selectedLibrary === 'My Favourites' || selectedLibrary === 'My Prompts' || selectedLibrary === 'Approval Pending'">
                                            <li  title="{{prompt.category_name}} > {{prompt.sub_category_name}}"                                          
                                              ><a href="#"  class="truncate-one-line" style="word-break: break-all;">{{prompt.category_name}}</a></li>
                                            <li   *ngIf="prompt.sub_category_name" [title]="prompt.sub_category_name"><a
                                                    href="#" class="truncate-one-line" >{{prompt.sub_category_name}}</a></li>
                                        </ul>
                                    </nav>
                                </div>
                                <div class="link-container" >
                                    <img *ngIf="prompt.prompt_type == 'chain'" class="chain-img"
                                        src="/assets/icons/Chain.svg" alt="Chain"/>
                                    <ng-container *ngIf="selectedLibrary === 'My Prompts'">
                                        <div class="prompt-status-indicator prompt-status-draft-indicator"
                                            *ngIf="prompt?.prompt_status == 'DRAFT'">
                                            <img src="/assets/icons/icon-status-draft.svg" alt="draft">
                                            <p class="prompt-status-indicator-text">Draft</p>
                                        </div>
                                        <div class="prompt-status-indicator prompt-status-submitted-indicator"
                                            *ngIf="prompt?.prompt_status == 'SUBMITTED'">
                                            <img src="/assets/icons/icon-status-submitted.svg" alt="submitted">
                                            <p class="prompt-status-indicator-text">Submitted</p>
                                        </div>
                                        <div class="prompt-status-indicator prompt-status-published-indicator"
                                            *ngIf="prompt?.prompt_status == 'PUBLISHED'">
                                            <img src="/assets/icons/icon-status-published.svg" alt="published">
                                            <p class="prompt-status-indicator-text">Published</p>
                                        </div>
                                        <div class="prompt-status-indicator prompt-status-rejected-indicator" 
                                            *ngIf="prompt?.prompt_status == 'REJECTED'" >
                                            <img src="/assets/icons/icon-status-rejected.svg" alt="rejected">
                                            <p class="prompt-status-indicator-text">Rejected</p>
                                        </div>
                                        <div class="prompt-status-indicator prompt-status-revoked-indicator" 
                                            *ngIf="prompt?.prompt_status == 'REVOKED'" >
                                            <img src="/assets/admin-images/revoked_icon.svg" alt="revoked">
                                            <p class="prompt-status-indicator-text">Revoked</p>
                                        </div>
                                        <div *ngIf="showVersionInstruction"  class="Tooltip" [ngStyle]="tooltipStyle">
                                            <div class="Content">
                                            <span class="reason-provided">
                                     {{version_reason}}
                                    </span>
                                    <div class="Line-55"></div>
                                    <span class="Created-From">
                                      <span class="style-1">Created From:</span>
                                      <span class="style-2"></span>
                                      {{created_from}}
                                    </span>
                                    </div>
                                    </div>
                                        <!-- user card content -->
                                        <div class="prompt-card-body-publish" *ngIf='this.user_role === "user"'>
                                            <div class="prompt-card-publish-date-publish" >
                                                <p class="prompt-card-publish-date-label">Published on:</p>
                                                <p>{{prompt.approved_or_rejected_datetime | dateTimeFormatter }}</p>
                                                <span class="Tag-container" [ngClass]="{'selected-tag': isSelectedForB(prompt?.version, prompt?.variant) }">
                                                    <span *ngIf="prompt?.variant>0" [ngClass]="{'Tag-publish-variant': isDrawerOpen,'variant Tag': !isDrawerOpen}" (mouseover)="showTooltip($event,'variant',prompt)"
                                                        (mouseleave)="hideTooltio('variant')">{{isDrawerOpen?'Var':'Variant'}} {{prompt?.variant}} &nbsp;<img src="/assets/icons/Info_white.svg" alt="Info_white"></span>
                                                </span>
                                                <span class="Tag-container" [ngClass]="{'selected-tag': isSelectedForA(prompt?.version, prompt?.variant) }">
                                                <span *ngIf="prompt?.version>0" (mouseover)="showTooltip($event,'version',prompt)"
                                                    (mouseleave)="hideTooltio('version')" [ngClass]="{'Tag-publish': isDrawerOpen,'Tag': !isDrawerOpen}">{{isDrawerOpen?'V':'Version'}} {{prompt?.version}} &nbsp;<img src="/assets/icons/Info_black.svg" alt="Info_black"></span>
                                                </span>
                                                
                                                    
                                                    
                                                </div>
                                            <div class="prompt-card-specifications">
                                                <div class="prompt-card-execution">
                                                    <img src="/assets/icons/execution-count.svg" alt="execution count">
                                                    <p>{{prompt.total_views}}</p>
                                                </div>
                                                <div class="prompt-card-star-rating">
                                                    <img src="/assets/icons/star_half.svg" alt="star rating">
                                                    <p>{{prompt.average_rating}}</p>
                                                </div>
                                                <div class="prompt-card-feed-back">
                                                    <img src="/assets/icons/execution-profile.svg" alt="profile count">
                                                    <p>{{prompt.total_feedbacks}}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- approver/curator card content -->
                                        <div class="prompt-card-body" *ngIf="this.user_role === 'curator' || this.user_role === 'admin'" style="height:96px;">
                                           
                                            
                                        </div>
                                        <!-- creator card content -->
                                        <div class="prompt-card-body" *ngIf='this.user_role === "creator"'>
                                            
                                            
                                        </div>
                                    </ng-container>
                                    <img *ngIf="selectedLibrary === 'My Favourites'"
                                        (click)="removeFavouite('remove', prompt.title, prompt.id)"
                                        src="/assets/icons/Favorite_Clicked.svg" alt="heart">
                                    
                                </div>
                            </div>
                            <div class="prompt-card-header" style="height: 45px;">
                                <p class="prompt-card-title" [title]="prompt.title">{{prompt.title}}</p>
                                <img *ngIf="prompt.prompt_type == 'chain' &&  (selectedLibrary != 'All Categories' && selectedLibrary != 'My Favourites' && selectedLibrary != 'My Prompts' && selectedLibrary != 'Approval Pending')"
                                 class="chain-img"
                                        src="/assets/icons/Chain.svg" alt="Chain" />
                            </div>
                            
                            <div class="prompt-card-body-publish"  *ngIf='this.user_role === "user"'>
                                <div class="prompt-card-publish-date-publish">
                                    <p class="prompt-card-publish-date-label">Published on:</p>
                                    <p>{{prompt.approved_or_rejected_datetime | dateTimeFormatter}}</p>
                                    <span class="Tag-container" [ngClass]="{'selected-tag': isSelectedForB(prompt?.version, prompt?.variant) }">
                                        <span *ngIf="prompt?.variant>0" [ngClass]="{'Tag-publish-variant': isDrawerOpen,'variant Tag': !isDrawerOpen}" (mouseover)="showTooltip($event,'variant',prompt)"
                                            (mouseleave)="hideTooltio('variant')">{{isDrawerOpen?'Var':'Variant'}} {{prompt?.variant}} &nbsp;<img src="/assets/icons/Info_white.svg" alt="Info_white"></span>
                                    </span> 
                                    <span class="Tag-container" [ngClass]="{'selected-tag': isSelectedForA(prompt?.version, prompt?.variant) }" >
                                    <span *ngIf="prompt?.version>0" (mouseover)="showTooltip($event,'version',prompt)"
                                        (mouseleave)="hideTooltio('version')" [ngClass]="{'Tag-publish': isDrawerOpen,'Tag': !isDrawerOpen}">{{isDrawerOpen?'V':'Version'}} {{prompt?.version}} &nbsp;<img src="/assets/icons/Info_black.svg" alt="Info_black"></span>
                                    </span>  
                                     
                                </div>
                                <div *ngIf="showVersionInstruction"  class="Tooltip" [ngStyle]="tooltipStyle">
                                    <div class="Content">
                                    <span class="reason-provided">
                             {{version_reason}}
                            </span>
                            <div class="Line-55"></div>
                            <span class="Created-From">
                              <span class="style-1">Created From:</span>
                              <span class="style-2"></span>
                              {{created_from}}
                            </span>
                            </div>
                            </div>
                            <div *ngIf="showVariantInstruction"  class="Tooltip" [ngStyle]="tooltipStyle">
                                <div class="Content">
                                <span class="reason-provided">
                         {{variant_reason}}
                        </span>
                        <div class="Line-55"></div>
                        <span class="Created-From">
                          <span class="style-1">Created From:</span>
                          <span class="style-2"></span>
                          {{variant_created_from}}
                        </span>
                        </div>
                        </div>

                                <div class="prompt-card-specifications">
                                    <div class="prompt-card-execution">
                                        <img src="/assets/icons/execution-count.svg" alt="execution count">
                                        <p>{{prompt.total_views}}</p>
                                    </div>
                                    <div class="prompt-card-star-rating">
                                        <img src="/assets/icons/star_half.svg" alt="star rating">
                                        <p>{{prompt.average_rating}}</p>
                                    </div>
                                    <div class="prompt-card-feed-back">
                                        <img src="/assets/icons/execution-profile.svg" alt="profile count">
                                        <p>{{prompt.total_feedbacks}}</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="prompt-card-body-publish"  *ngIf="(this.user_role === 'curator' || this.user_role === 'admin') && prompt.prompt_status != 'SUBMITTED'">
                                <div class="prompt-card-publish-date-publish" *ngIf="prompt?.prompt_status == 'PUBLISHED' || prompt?.prompt_status == 'REVOKED'">

                                    <p class="prompt-card-publish-date-label">{{prompt?.prompt_status == 'REVOKED'? 'Revoked on' : 'Published on' }} :</p>

                                    <p>{{prompt.approved_or_rejected_datetime | dateTimeFormatter}}</p>
                                    <span class="Tag-container" [ngClass]="{'selected-tag': isSelectedForB(prompt?.version, prompt?.variant) }">
                                        <span *ngIf="prompt?.variant>0" [ngClass]="{'Tag-publish-variant': isDrawerOpen,'variant Tag': !isDrawerOpen}" (mouseover)="showTooltip($event,'variant',prompt)"
                                            (mouseleave)="hideTooltio('variant')">{{isDrawerOpen?'Var':'Variant'}} {{prompt?.variant}} &nbsp;<img src="/assets/icons/Info_white.svg" alt="Info_white"></span>
                                    </span>
                                    <span class="Tag-container" [ngClass]="{'selected-tag': isSelectedForA(prompt?.version, prompt?.variant) }">
                                    <span *ngIf="prompt?.version>0" [ngClass]="{'Tag-publish': isDrawerOpen,'Tag': !isDrawerOpen}" (mouseover)="showTooltip($event,'version',prompt)"
                                        (mouseleave)="hideTooltio('version')">{{isDrawerOpen?'V':'Version'}} {{prompt?.version}} &nbsp;<img src="/assets/icons/Info_black.svg" alt="Info_black"></span>
                                    </span>   
                                    

                                        <div *ngIf="showVersionInstruction"  class="Tooltip" [ngStyle]="tooltipStyle">
                                            <div class="Content">
                                            <span class="reason-provided">
                                     {{version_reason}}
                                    </span>
                                    <div class="Line-55"></div>
                                    <span class="Created-From">
                                      <span class="style-1">Created From:</span>
                                      <span class="style-2"></span>
                                      {{created_from}}
                                    </span>
                                    </div>
                                    </div>
                                    <div *ngIf="showVariantInstruction"  class="Tooltip" [ngStyle]="tooltipStyle">
                                        <div class="Content">
                                        <span class="reason-provided">
                                 {{variant_reason}}
                                </span>
                                <div class="Line-55"></div>
                                <span class="Created-From">
                                  <span class="style-1">Created From:</span>
                                  <span class="style-2"></span>
                                  {{variant_created_from}}
                                </span>
                                </div>
                                </div>
                                    </div>
                                <div class="prompt-card-publish-date" style=" flex-wrap: wrap !important; " *ngIf="prompt?.prompt_status == 'DRAFT'">
                                    <p class="prompt-card-publish-date-label" *ngIf="!prompt?.is_withdrawn">Saved on:</p>
                                    <p *ngIf="!prompt?.is_withdrawn">{{prompt.prompt_version_date_time | dateTimeFormatter}}</p>
                                    <p class="prompt-card-publish-date-label" *ngIf="prompt?.is_withdrawn">Withdrawn on:</p>
                                    <p *ngIf="prompt?.is_withdrawn">{{prompt.approved_or_rejected_datetime | dateTimeFormatter}}</p>
                                    <span class="Tag-container-submit save" [ngClass]="{'selected-tag': isSelectedForB(prompt?.version, prompt?.variant) }">
                                        <span *ngIf="prompt?.variant>0" [ngClass]="{'Tag-publish-variant': isDrawerOpen,'variant Tag': !isDrawerOpen}" (mouseover)="showTooltip($event,'variant',prompt)"
                                            (mouseleave)="hideTooltio('variant')">{{isDrawerOpen?'Var':'Variant'}} {{prompt?.variant}} &nbsp;<img src="/assets/icons/Info_white.svg" alt="Info_white"></span>
                                    </span>
                                    <span class="Tag-container-submit save" [ngClass]="{'selected-tag': isSelectedForA(prompt?.version, prompt?.variant) }">
                                    <span *ngIf="prompt?.version>0" [ngClass]="{'Tag-publish': isDrawerOpen,'Tag': !isDrawerOpen}" (mouseover)="showTooltip($event,'version',prompt)"
                                        (mouseleave)="hideTooltio('version')">{{isDrawerOpen?'V':'Version'}} {{prompt?.version}} &nbsp;<img src="/assets/icons/Info_black.svg" alt="Info_black"></span>
                                    </span>

                                    
                                        
                                        <div *ngIf="showVersionInstruction"  class="Tooltip" [ngStyle]="tooltipStyle">
                                            <div class="Content">
                                            <span class="reason-provided">
                                     {{version_reason}}
                                    </span>
                                    <div class="Line-55"></div>
                                    <span class="Created-From">
                                      <span class="style-1">Created From:</span>
                                      <span class="style-2"></span>
                                      {{created_from}}
                                    </span>
                                    </div>
                                    </div>
                                    <div *ngIf="showVariantInstruction"  class="Tooltip" [ngStyle]="tooltipStyle">
                                        <div class="Content">
                                        <span class="reason-provided">
                                 {{variant_reason}}
                                </span>
                                <div class="Line-55"></div>
                                <span class="Created-From">
                                  <span class="style-1">Created From:</span>
                                  <span class="style-2"></span>
                                  {{variant_created_from}}
                                </span>
                                </div>
                                </div>
                                
                                </div>

                                <div class="prompt-card-publish-date" style=" flex-wrap: wrap !important; " *ngIf="prompt?.prompt_status == 'REJECTED'" >
                                    <p class="prompt-card-publish-date-label">Rejected on:</p>
                                    <p>{{prompt.approved_or_rejected_datetime | dateTimeFormatter }}</p>
                                </div>

                               
                                <div class="prompt-card-specifications" >
                                    <ng-container *ngIf="prompt?.prompt_status == 'PUBLISHED' || prompt?.prompt_status == 'REVOKED'">
                                      
                                    <div class="prompt-card-execution">
                                        <img src="/assets/icons/execution-count.svg" alt="execution count">
                                        <p>{{prompt.total_views}}</p>
                                    </div>
                                    <div class="prompt-card-star-rating">
                                        <img src="/assets/icons/star_half.svg" alt="star rating">
                                        <p>{{prompt.average_rating}}</p>
                                    </div>
                                    <div class="prompt-card-feed-back">
                                        <img src="/assets/icons/execution-profile.svg" alt="profile count">
                                        <p>{{prompt.total_feedbacks}}</p>
                                    </div>
                                    </ng-container>
                                </div>
                            </div>
                            <div class="prompt-card-body" *ngIf="(this.user_role === 'curator' || this.user_role === 'admin') && prompt.prompt_status == 'SUBMITTED'">
                                <div class="prompt-card-publish-date" style="min-height: 30px;flex-wrap: wrap !important; " *ngIf="selectedLibrary != 'My Prompts'" >
                                    <p class="prompt-card-publish-date-label">Submitted by:</p>
                                    <div class="submitter">
                                        <img src="/assets/icons/execution-profile.svg" alt=" profile pic">
                                        <p>{{prompt.prompt_creator_name}}</p>
                                    </div>
                                </div>
                                <div class="prompt-card-publish-date" style="min-height: 58px;padding-bottom: 14px;flex-wrap: wrap !important;" *ngIf="selectedLibrary == 'My Prompts'" >
                                    <p class="prompt-card-publish-date-label">Submitted on:</p>
                                    <p>{{prompt.prompt_version_date_time | dateTimeFormatter }}</p>
                                    <span class="Tag-container-submit save" [ngClass]="{'selected-tag': isSelectedForB(prompt?.version, prompt?.variant) }">
                                        <span *ngIf="prompt?.variant>0" [ngClass]="{'Tag-publish-variant': isDrawerOpen,'variant Tag': !isDrawerOpen}" (mouseover)="showTooltip($event,'variant',prompt)"
                                            (mouseleave)="hideTooltio('variant')">{{isDrawerOpen?'Var':'Variant'}} {{prompt?.variant}} &nbsp;<img src="/assets/icons/Info_white.svg" alt="Info_white"></span>
                                    </span>
                                    <span class="Tag-container-submit" [ngClass]="{'selected-tag': isSelectedForA(prompt?.version, prompt?.variant) }">
                                    <span *ngIf="prompt?.version>0" [ngClass]="{'Tag-publish': isDrawerOpen,'Tag': !isDrawerOpen}" (mouseover)="showTooltip($event,'version',prompt)"
                                        (mouseleave)="hideTooltio('version')">{{isDrawerOpen?'V':'Version'}} {{prompt?.version}} &nbsp;<img src="/assets/icons/Info_black.svg" alt="Info_black"></span>
                                    </span>  
                                      
                                    </div>
                                <div class="prompt-card-publish-date" style="min-height: 30px;flex-wrap: wrap !important;" *ngIf="selectedLibrary != 'My Prompts'" >
                                    <p class="prompt-card-publish-date-label">Submitted on:</p>
                                    <p>{{prompt.prompt_version_date_time | dateTimeFormatter }}</p>
                                    <span class="Tag-container-submit save" [ngClass]="{'selected-tag': isSelectedForB(prompt?.version, prompt?.variant) }">
                                        <span *ngIf="prompt?.variant>0" [ngClass]="{'Tag-publish-variant': isDrawerOpen,'variant Tag': !isDrawerOpen}" (mouseover)="showTooltip($event,'variant',prompt)"
                                            (mouseleave)="hideTooltio('variant')">{{isDrawerOpen?'Var':'Variant'}} {{prompt?.variant}} &nbsp;<img src="/assets/icons/Info_white.svg" alt="Info_white"></span>
                                    </span>
                                    <span class="Tag-container-submit" [ngClass]="{'selected-tag': isSelectedForA(prompt?.version, prompt?.variant) }">
                                    <span *ngIf="prompt?.version>0" [ngClass]="{'Tag-publish': isDrawerOpen,'Tag': !isDrawerOpen}" (mouseover)="showTooltip($event,'version',prompt)"
                                        (mouseleave)="hideTooltio('version')">{{isDrawerOpen?'V':'Version'}} {{prompt?.version}} &nbsp;<img src="/assets/icons/Info_black.svg" alt="Info_black"></span>
                                    </span>
                                   

                                    </div>
                                <div *ngIf="showVersionInstruction"  class="Tooltip" [ngStyle]="tooltipStyle">
                                    <div class="Content">
                                    <span class="reason-provided">
                             {{version_reason}}
                            </span>
                            <div class="Line-55"></div>
                            <span class="Created-From">
                              <span class="style-1">Created From:</span>
                              <span class="style-2"></span>
                              {{created_from}}
                            </span>
                            </div>
                            </div>
                            <div *ngIf="showVariantInstruction"  class="Tooltip" [ngStyle]="tooltipStyle">
                                <div class="Content">
                                <span class="reason-provided">
                         {{variant_reason}}
                        </span>
                        <div class="Line-55"></div>
                        <span class="Created-From">
                          <span class="style-1">Created From:</span>
                          <span class="style-2"></span>
                          {{variant_created_from}}
                        </span>
                        </div>
                        </div>
                            </div>
                            
                            <div class="prompt-card-body"   *ngIf='this.user_role === "creator"' style="height:96px;">
                                <!-- creator published card content  -->
                                <div class="prompt-card-publish-date-publish" style="padding-bottom:12px;" *ngIf="prompt?.prompt_status == 'PUBLISHED' || prompt?.prompt_status == 'REVOKED'">

                                    <p class="prompt-card-publish-date-label">{{prompt?.prompt_status == 'REVOKED'? 'Revoked on' : 'Published on' }} :</p>

                                    <p>{{prompt.approved_or_rejected_datetime | dateTimeFormatter }}</p>
                                    <span class="Tag-container" [ngClass]="{'selected-tag': isSelectedForB(prompt?.version, prompt?.variant) }">
                                        <span *ngIf="prompt?.variant>0" [ngClass]="{'Tag-publish-variant': isDrawerOpen,'variant Tag': !isDrawerOpen}" (mouseover)="showTooltip($event,'variant',prompt)"
                                            (mouseleave)="hideTooltio('variant')">{{isDrawerOpen?'Var':'Variant'}} {{prompt?.variant}} &nbsp;<img src="/assets/icons/Info_white.svg" alt="Info_white"></span>
                                    </span>
                                    <span class="Tag-container" [ngClass]="{'selected-tag': isSelectedForA(prompt?.version, prompt?.variant) }">
                                    <span *ngIf="prompt?.version>0" [ngClass]="{'Tag-publish': isDrawerOpen,'Tag': !isDrawerOpen}" (mouseover)="showTooltip($event,'version',prompt)"
                                        (mouseleave)="hideTooltio('version')">{{isDrawerOpen?'V':'Version'}} {{prompt?.version}} &nbsp;<img src="/assets/icons/Info_black.svg" alt="Info_black"></span>
                                    </span> 
                                    

                                    </div>

                                <div *ngIf="showVersionInstruction"  class="Tooltip" [ngStyle]="tooltipStyle">
                                    <div class="Content">
                                    <span class="reason-provided">
                             {{version_reason}}
                            </span>
                            <div class="Line-55"></div>
                            <span class="Created-From">
                              <span class="style-1">Created From:</span>
                              <span class="style-2"></span>
                              {{created_from}}
                            </span>
                            </div>
                            </div>
                            <div *ngIf="showVariantInstruction"  class="Tooltip" [ngStyle]="tooltipStyle">
                                <div class="Content">
                                <span class="reason-provided">
                         {{variant_reason}}
                        </span>
                        <div class="Line-55"></div>
                        <span class="Created-From">
                          <span class="style-1">Created From:</span>
                          <span class="style-2"></span>
                          {{variant_created_from}}
                        </span>
                        </div>
                        </div>
                              
                                <!-- creator submitted card content -->
                                <div class="prompt-card-publish-date" *ngIf="prompt?.prompt_status == 'SUBMITTED'">
                                    <p class="prompt-card-publish-date-label">Submitted on:</p>
                                    <p>{{prompt.prompt_version_date_time | dateTimeFormatter}}</p>
                                    <span class="Tag-container-submit save" [ngClass]="{'selected-tag': isSelectedForB(prompt?.version, prompt?.variant) }" >
                                        <span *ngIf="prompt?.variant>0" [ngClass]="{'Tag-publish-variant': isDrawerOpen,'variant Tag': !isDrawerOpen}" (mouseover)="showTooltip($event,'variant',prompt)"
                                            (mouseleave)="hideTooltio('variant')">{{isDrawerOpen?'Var':'Variant'}} {{prompt?.variant}} &nbsp;<img src="/assets/icons/Info_white.svg" alt="Info_white"></span>
                                    </span>
                                    <span class="Tag-container-submit" [ngClass]="{'selected-tag': isSelectedForA(prompt?.version, prompt?.variant) }" >
                                    <span *ngIf="prompt?.version>0" [ngClass]="{'Tag-publish': isDrawerOpen,'Tag': !isDrawerOpen}" (mouseover)="showTooltip($event,'version',prompt)"
                                        (mouseleave)="hideTooltio('version')">{{isDrawerOpen?'V':'Version'}} {{prompt?.version}} &nbsp;<img src="/assets/icons/Info_black.svg" alt="Info_black"></span>
                                    </span>
                                    
                                        
                                </div>
                                <!-- creator rejected card content -->
                                <div class="prompt-card-publish-date" style=" flex-wrap: wrap !important; " *ngIf="prompt?.prompt_status == 'REJECTED'" >
                                    <p class="prompt-card-publish-date-label">Rejected on:</p>
                                    <p>{{prompt.approved_or_rejected_datetime | dateTimeFormatter }}</p>
                                    <span class="Tag-container-submit" [ngClass]="{'selected-tag': isSelectedForA(prompt?.version, prompt?.variant) }">
                                    <span *ngIf="prompt?.version>0" (mouseover)="showTooltip($event,'version',prompt)"
                                        (mouseleave)="hideTooltio('version')" [ngClass]="{'Tag-publish': isDrawerOpen,'Tag': !isDrawerOpen}">{{isDrawerOpen?'V':'Version'}} {{prompt?.version}} &nbsp;<img src="/assets/icons/Info_black.svg" alt="Info_white"></span>
                                    </span>
                                    <span class="Tag-container-submit" [ngClass]="{'selected-tag': isSelectedForB(prompt?.version, prompt?.variant) }">
                                        <span *ngIf="prompt?.variant>0" [ngClass]="{'Tag-publish-variant': isDrawerOpen,'variant Tag': !isDrawerOpen}" (mouseover)="showTooltip($event,'variant',prompt)"
                                            (mouseleave)="hideTooltio('variant')">{{isDrawerOpen?'Var':'Variant'}} {{prompt?.variant}} &nbsp;<img src="/assets/icons/Info_white.svg" alt="Info_white"></span>
                                    </span>
                                    </div>
                                
                                <div class="prompt-card-publish-date"  style=" flex-wrap: wrap !important; " *ngIf="prompt?.prompt_status == 'DRAFT'">
                                    <p class="prompt-card-publish-date-label" *ngIf="!prompt?.is_withdrawn">Saved on:</p>
                                    <p *ngIf="!prompt?.is_withdrawn">{{prompt.prompt_version_date_time | dateTimeFormatter}}</p>
                                    <p class="prompt-card-publish-date-label" *ngIf="prompt?.is_withdrawn">Withdrawn on:</p>
                                    <p *ngIf="prompt?.is_withdrawn">{{prompt.approved_or_rejected_datetime | dateTimeFormatter}}</p>
                                    <span class="Tag-container-submit save" [ngClass]="{'selected-tag': isSelectedForB(prompt?.version, prompt?.variant) }">
                                        <span *ngIf="prompt?.variant>0" [ngClass]="{'Tag-publish-variant': isDrawerOpen,'variant Tag': !isDrawerOpen}" (mouseover)="showTooltip($event,'variant',prompt)"
                                            (mouseleave)="hideTooltio('variant')">{{isDrawerOpen?'Var':'Variant'}} {{prompt?.variant}} &nbsp;<img src="/assets/icons/Info_white.svg" alt="Info_white"></span>
                                    </span>
                                    <span class="Tag-container-submit save" [ngClass]="{'selected-tag': isSelectedForA(prompt?.version, prompt?.variant) }">
                                    <span *ngIf="prompt?.version>0" [ngClass]="{'Tag-publish': isDrawerOpen,'Tag': !isDrawerOpen}" (mouseover)="showTooltip($event,'version',prompt)"
                                        (mouseleave)="hideTooltio('version')">{{isDrawerOpen?'V':'Version'}} {{prompt?.version}} &nbsp;<img src="/assets/icons/Info_black.svg" alt="Info_white"></span>
                                    </span>
                                    
                                   
                                        <div *ngIf="showVersionInstruction"  class="Tooltip" [ngStyle]="tooltipStyle">
                                            <div class="Content">
                                            <span class="reason-provided">
                                     {{version_reason}}
                                    </span>
                                    <div class="Line-55"></div>
                                    <span class="Created-From">
                                      <span class="style-1">Created From:</span>
                                      <span class="style-2"></span>
                                      {{created_from}}
                                    </span>
                                    </div>
                                    </div>
                                    <div *ngIf="showVariantInstruction"  class="Tooltip" [ngStyle]="tooltipStyle">
                                        <div class="Content">
                                        <span class="reason-provided">
                                 {{variant_reason}}
                                </span>
                                <div class="Line-55"></div>
                                <span class="Created-From">
                                  <span class="style-1">Created From:</span>
                                  <span class="style-2"></span>
                                  {{variant_created_from}}
                                </span>
                                </div>
                                </div>
                                
                                    </div>
                                <div class="prompt-card-specifications" >
                                    <ng-container *ngIf="prompt?.prompt_status == 'PUBLISHED' || prompt?.prompt_status == 'REVOKED'">
                                       
                                    <div class="prompt-card-execution">
                                        <img src="/assets/icons/execution-count.svg" alt="execution count">
                                        <p>{{prompt.total_views}}</p>
                                    </div>
                                    <div class="prompt-card-star-rating">
                                        <img src="/assets/icons/star_half.svg" alt="star rating">
                                        <p>{{prompt.average_rating}}</p>
                                    </div>
                                    <div class="prompt-card-feed-back">
                                        <img src="/assets/icons/execution-profile.svg" alt="profile count">
                                        <p>{{prompt.total_feedbacks}}</p>
                                    </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
       
    </div>
    <div class="form-container" >
        <div class="form-content">
            <div class="form-header">
                <div class="flex-disp-between">
                    <div class="images-div">
                        <div class="side-panel-header-content-section">
                            <img src="/assets/icons/play_circle.svg" alt="play_circle"/><span>{{
                                promptUserDetails?.total_views
                                }}</span>
                        </div>
                        <div class="side-panel-header-content-section">
                            <img src="/assets/icons/Star.svg" alt=""/><span>{{
                                promptUserDetails?.average_rating
                                }}</span>
                        </div>
                        <div class="side-panel-header-content-section">
                            <img src="/assets/icons/Profile star.svg" alt="" /><span>{{
                                promptUserDetails?.total_feedbacks
                                }}</span>
                        </div>
                    </div>
                    <div>
                        
                        <div style="cursor: pointer; margin-right: 9px; color: #0F1A2E;"
                            (click)="toggleDrawer()">
                            <img src="/assets/icons/Close.svg" alt="" />
                        </div>
                    </div>
                </div>
                <!-- breadcrumb -->
                <div>
                    <nav class="breadcrumb" aria-labelledby="breadcrumb">
                        <ul>
                            <li title="{{ promptCategory }} > {{sub_category}}">
                                <a href="#" class="truncate-one-line"> {{ promptCategory }}</a>
                            </li>
                            <li *ngIf="sub_category" title="{{sub_category}}"><a href="#" class="truncate-one-line">{{sub_category}}</a></li>
                        </ul>
                        <img *ngIf="promptUserDetails?.prompt_type == 'chain'" class="icon-chain"
                            src="/assets/icons/Chain.svg" alt=""/> 
                            <span *ngIf="promptUserDetails?.variant > 0" (mouseover)="showTooltip($event,'variant',promptUserDetails)"
                                (mouseleave)="hideTooltio('variant')"  class="Tag-preview variant">Variant {{promptUserDetails?.variant}} &nbsp;<img src="/assets/icons/Info_white.svg" alt=""></span>
                            <span *ngIf="promptUserDetails?.version > 0" (mouseover)="showTooltip($event,'version',promptUserDetails)"
                                (mouseleave)="hideTooltio('version')"  class="Tag-preview">Version {{promptUserDetails?.version}} &nbsp;<img src="/assets/icons/Info_black.svg" alt=""></span>
                                
                           
                        </nav>
                </div>
            </div>

            <div class="form-context">
                <div class="expanded-card" [ngClass]="{'expanded': isExpand}" #expandable>
                    <div class="prompt-main-txt">{{ promptUserDetails?.title }}  </div>
                    <div class="prompt-description-text">{{promptUserDetails?.description}}</div>
                    <div class="disp-block img-div">
                        <div class="display-flex-center">
                            <img style="width: 20px; height: 20px" src="/assets/icons/Chip.svg" alt="" /><span>{{ gptScore
                                }}</span>
                        </div>
                        <div class="display-flex-center">
                            <img style="width: 20px; height: 20px" src="/assets/icons/Profile.svg" alt=""/><span>Created by:
                                {{
                                promptCreatedBy }}</span>
                        </div>
                        <div class="display-flex-center">
                            <img style="width: 20px; height: 20px" src="/assets/icons/Calender.svg" alt="" /><span>Published
                                on:
                                {{ published_on | dateTimeFormatter }}</span>
                        </div>
                        
                    </div>
                    <div class="expandable-handler" *ngIf="isExpandableContentOverflowed"
                        [ngClass]="{'rotate-expand': isExpand}">
                        <img src="/assets/icons/keyboard_double_arrow_up.svg" alt="" (click)="onClickExpand($event)" />
                    </div>
                </div>

                <mat-divider></mat-divider>

                <div class="stepper" *ngIf="promptUserDetails?.prompt_type === 'chain'">
                    
                    <mat-horizontal-stepper [disableRipple]="true" labelPosition="bottom" #stepper [selectedIndex]="selectedIndex"  [linear]="true" (selectionChange)="changePromptDetails($event)">
                        <ng-template matStepperIcon="edit" let-index="index">
                            <span *ngIf="isStepCompleted(index); else defaultIcon">&#10004;</span>
                            <ng-template #defaultIcon>{{ index + 1 }}</ng-template>
                          </ng-template>
                        <mat-step *ngFor="let i of promptUserDetails?.prompt_details ; let a = index; trackBy: trackByIndex">
                            <ng-template matStepLabel>Prompt {{a+1}} </ng-template>
                            <div>
                                <div>
                                    <div class="mtb-10 prompt-main-txt">{{i.prompt_name }}</div>
                                    <div class="flex-disp-between mtb-10">
                                        <div class="color-prompt">Prompt</div>
                                    </div>
                                    <p class="prompt-text" [style.white-space]="'pre-wrap'">
                                        {{ i.prompt }}
                                    </p>
                                </div>
                                
                                <div>
                                    <div class="label-txt">Attachments <img src="/assets/icons/Icon_badge.svg" alt=""  title="Upload a document for analysis, summarization or data extraction."/></div>
                                    <div class="drop-div"
                                        (dragover)="onDragOver($event, 'otherAttachment',a)"
                                        (dragleave)="onDragLeave($event, 'otherAttachment',a)"
                                        (drop)="onDrop($event, 'otherAttachment',a)">
                                        <div>
                                            <div class="dropzone">
                                                <div class="text-wrapper">
                                                    <div class="centered">
                                                        <mat-icon class="upload-img">
                                                            <img src="/assets/icons/Upload.svg" alt="" />
                                                        </mat-icon>
                                                        <input type="file" name="file_{{a}}" id="file_{{a}}" (change)="onFileChange($event, 'otherAttachment', a)"
                                                            accept="*" multiple>
                                                        <label for="file_{{a}}" class="drop-txt">Drag and drop your files here or
                                                            <span class="click-here" (change)="onFileChange($event, 'otherAttachment',a)">Click here</span> to
                                                            upload</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="files-list" *ngIf="attachmentTabs[a].attachmentForm.value.otherAttachment && attachmentTabs[a].attachmentForm.value.otherAttachment.length">
                                        <div class="upload-files-list">
                                            @for (attachment of attachmentTabs[a].attachmentForm.value.otherAttachment; track attachment; let attachment_index = $index){
                                            <div class="single-file">
                                                <div class="file-icon">
                                                    @if(attachment?.file_type == "pdf") {
                                                        <img src="/assets/icons/pdf.svg" alt="file" />
                                                    } @else if(attachment?.file_type == "docx" || attachment?.file_type == "doc") {
                                                        <img src="/assets/icons/doc.svg" alt="file" />
                                                    } @else if(attachment?.file_type == "jpg" || attachment?.file_type == "jpeg") {
                                                        <img src="/assets/icons/jpg.svg" alt="file" />
                                                    } @else if(attachment?.file_type == "png") {
                                                        <img src="/assets/icons/png.svg" alt="file" />
                                                    } @else if(attachment?.file_type == "svg") {
                                                        <img src="/assets/icons/svg.svg" alt="file" />
                                                    } @else if(attachment?.file_type == "ppt" || attachment?.file_type == "pptx") {
                                                        <img src="/assets/icons/ppt.svg" alt="file" />
                                                    } @else if(attachment?.file_type == "xlsx" || attachment?.file_type == "xls") {
                                                        <img src="/assets/icons/xls.svg" alt="file" />
                                                    } @else if(attachment?.file_type == "csv") {
                                                        <img src="/assets/icons/csv.svg" alt="file" />
                                                    } @else {
                                                        <img src="/assets/icons/pdf.svg" alt="file" />
                                                    }
                                                </div>
                                                <div class="info">
                                                    <h4 class="name">
                                                        {{ attachment?.selected?.name ? attachment?.selected?.name : 'file' }}
                                                    </h4>
                                                </div>
                                                <div class="delete"
                                                    (click)="deleteFile(attachment_index, 'otherAttachment', a, attachment?.selected?.name)">
                                                    <img src="/assets/icons/delete-blue.svg"
                                                        alt="delete" />
                                                </div>
                                            </div>
                                            }
                                        </div>
        
        
                                    </div>
                                    
                                </div>
                                @if(i.variables.length > 0) {
                                    <div class="form-fild">
                                        <div class="var_reset-dev">
                                            <div class="label-txt">Variables</div>
                                        </div>
                                        <form>
                                            @for(variable of i.variables; track $index; let v = $index) {
                                                @if(isString(variable)) {
                                                    <mat-form-field class="form-field" style="width: 100%;" >
                                                        <mat-label class="variable_label">{{variable}}</mat-label>
                                                        <input disabled value="" type="text" matInput />
                                                    </mat-form-field>
                                                } @else if(isArray(variable)) {
                                                    <mat-form-field style="width: 100%;" class="form-field">
                                                        @for (option of variable; track $index; let o = $index) {
                                                            <mat-label class="variable_label">{{option}} 
                                                                @if(o < variable.length - 1) {
                                                                    /
                                                                }
                                                            </mat-label>
                                                        }
                                                        <mat-select name="topic" 
                                                            [(value)]="tabs[a].myForm.value.variablesCopy[v]"
                                                            (selectionChange)="onVariableChange(v, $event, true, a)"
                                                            disabled
                                                            >
                                                            @for (option of variable; track $index) {
                                                                <mat-option [value]="option">{{ option }}</mat-option>
                                                            }
                                                        </mat-select>
                                                    </mat-form-field>
                                                } @else {
                                                    <div class="variable-tag-wrap">
                                                        <mat-form-field class="form-field" style="width: 100%;">
                                                            <mat-label class="variable_label">{{variable.varGptData}}</mat-label>
                                                            <input disabled value="" type="text" matInput />
                                                        </mat-form-field>
                                                    </div>
                                                }
                                            }
                                        </form>
                                        
                                    </div>
                                }
                                
                                <div>
                                   
                                    
                                </div>
                                <div>
                                    <div class="label-txt">Notes </div>
                                    
                                    <div *ngIf="i">
                                        <div class="privacy-txt">{{i?.notes}}</div>
                                      
                                    </div> 
                                </div>
                            </div>
                        </mat-step>

                        <ng-template matStepperIcon="done">
                            <img src="/assets/icons/Badgegreen-check.svg" alt="done_img" width="24" height="24" />
                        </ng-template>

                        
                    </mat-horizontal-stepper>
                </div>

                <div *ngIf="promptUserDetails?.prompt_type !== 'chain'">
                    <div>
                        <div class="flex-disp-between mtb-10">
                            <div class="color-prompt">Prompt</div>
                        </div>
                        <p class="prompt-text" [style.white-space]="'pre-wrap'">
                            {{ promptUserDetails?.prompt_details[0].prompt }}
                        </p>
                    </div>

                    <div>
                        <div class="label-txt">Attachments <img src="/assets/icons/Icon_badge.svg" alt="" title="Upload a document for analysis, summarization or data extraction."  /></div>
                        <div class="drop-div"
                            (dragover)="onDragOver($event, 'otherAttachment', 0)"
                            (dragleave)="onDragLeave($event, 'otherAttachment',0)"
                            (drop)="onDrop($event, 'otherAttachment', 0)">
                            <div>

                                <div class="dropzone">
                                    <div class="text-wrapper">
                                        <div class="centered">
                                            <mat-icon class="upload-img">
                                                <img src="/assets/icons/Upload.svg" alt="" />
                                            </mat-icon>
                                            <input type="file" name="file" id="file" (change)="onFileChange($event, 'otherAttachment', 0)"
                                                accept="*" multiple>
                                            <label for="file" class="drop-txt">Drag and drop your files here or
                                                <span class="click-here" (change)="onFileChange($event, 'otherAttachment', 0)">Click here</span> to
                                                upload</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="files-list" *ngIf="attachmentTabs.length">
                            <div class="upload-files-list">
                                @for (attachment of attachmentTabs[0].attachmentForm.value.otherAttachment; track attachment; let attachment_index = $index){
                                <div class="single-file">
                                    <div class="file-icon">
                                        @if(attachment?.file_type == "pdf") {
                                            <img src="/assets/icons/pdf.svg" alt="file" />
                                        } @else if(attachment?.file_type == "docx" || attachment?.file_type == "doc") {
                                            <img src="/assets/icons/doc.svg" alt="file" />
                                        } @else if(attachment?.file_type == "jpg" || attachment?.file_type == "jpeg") {
                                            <img src="/assets/icons/jpg.svg" alt="file" />
                                        } @else if(attachment?.file_type == "png") {
                                            <img src="/assets/icons/png.svg" alt="file" />
                                        } @else if(attachment?.file_type == "svg") {
                                            <img src="/assets/icons/svg.svg" alt="file" />
                                        } @else if(attachment?.file_type == "ppt" || attachment?.file_type == "pptx") {
                                            <img src="/assets/icons/ppt.svg" alt="file" />
                                        } @else if(attachment?.file_type == "xlsx" || attachment?.file_type == "xls") {
                                            <img src="/assets/icons/xls.svg" alt="file" />
                                        } @else if(attachment?.file_type == "csv") {
                                            <img src="/assets/icons/csv.svg" alt="file" />
                                        } @else {
                                            <img src="/assets/icons/pdf.svg" alt="file" />
                                        }
                                    </div>
                                    <div class="info">
                                        <h4 class="name">
                                            {{ attachment?.selected?.name ? attachment?.selected?.name : 'file' }}
                                        </h4>
                                    </div>
                                    <div class="delete"
                                        (click)="deleteFile(attachment_index, 'otherAttachment', 0, attachment?.selected?.name)">
                                        <img src="/assets/icons/delete-blue.svg"
                                            alt="delete" />
                                    </div>
                                </div>
                                }
                            </div>


                        </div>
                        
                        
                    </div>
                    @if(promptUserDetails?.prompt_details[0].variables.length > 0) {
                        <div class="form-fild">
                            <div class="var_reset-dev">
                                <div class="label-txt">Variables</div>
                            </div>
                            <form>
                                @for(variable of promptUserDetails?.prompt_details[0].variables; track $index; let v = $index) {
                                    @if(isString(variable)) {
                                        <mat-form-field class="form-field" style="width: 100%;" >
                                            <mat-label class="variable_label">{{variable}}</mat-label>
                                            <input disabled value="" type="text" matInput />
                                        </mat-form-field>
                                    } @else if(isArray(variable)) {
                                        <mat-form-field style="width: 100%;" class="form-field">
                                            @for (option of variable; track $index; let o = $index) {
                                                <mat-label class="variable_label">{{option}} 
                                                    @if(o < variable.length - 1) {
                                                        /
                                                    }
                                                </mat-label>
                                            }
                                            <mat-select name="topic" 
                                                [(value)]="tabs[0].myForm.value.variablesCopy[v]"
                                                (selectionChange)="onVariableChange(v, $event, true, 0)"
                                                disabled
                                                >
                                                @for (option of variable; track $index) {
                                                    <mat-option [value]="option">{{ option }}</mat-option>
                                                }
                                            </mat-select>
                                        </mat-form-field>
                                    } @else {
                                        <div class="variable-tag-wrap">
                                            <mat-form-field class="form-field" style="width: 100%;">
                                                <mat-label class="variable_label">{{variable.varGptData}}</mat-label>
                                                <input disabled value="" type="text" matInput />
                                            </mat-form-field>
                                        </div>
                                    }
                                }
                            </form>
                        </div>
                    }
                   
                    <div>
                      
                        
                    </div>
                    <div>
                        <div class="label-txt">Notes </div>
                       
                        <div>
                            <p class="privacy-txt">{{promptUserDetails?.prompt_details[0]?.notes}}</p>
                            
                        </div>
                    </div>
                </div>

                
            </div>

            <div class="form-footer">
                <div class="flex-disp-between">
                    <div class="flex-disp-between">
                        <div class="hrt" *ngIf="!isfavourite && promptUserDetails?.prompt_details[0]?.status === 'PUBLISHED'">
                            <mat-icon (click)="addToFavouite('add')">
                                <img src="/assets/icons/Favorite.svg" alt="" />
                            </mat-icon>
                        </div>
                        <div class="hrtclicked" *ngIf="isfavourite && promptUserDetails?.prompt_details[0]?.status === 'PUBLISHED'">
                            
                            <mat-icon (click)="removeFavouite('remove', promptUserDetails?.title, promptUserDetails?.prompt_id)">
                                <img src="/assets/icons/Favorite_Clicked.svg" alt="" />
                            </mat-icon>

                        </div>
                        <div class="hrt" *ngIf="promptUserDetails?.prompt_details[0]?.status === 'PUBLISHED' && promptUserDetails?.is_user_executed" [ngClass]="{'bg-org' : promptUserDetails?.my_rating !== 0}"
                            style="width: auto;" (click)="addToFeedback($event, promptUserDetails?.prompt_id, promptUserDetails?.title)">
                            <mat-icon *ngIf="promptUserDetails?.my_rating == 0">
                                <img src="/assets/icons/star_rate.svg" alt="" />
                            </mat-icon>

                            <div *ngIf="promptUserDetails?.my_rating !== 0" class="avg_rate">
                                <mat-icon>
                                    <img src="/assets/icons/Starfill.svg" alt="" />
                                </mat-icon>
                                {{promptUserDetails?.my_rating}}
                            </div>
                        </div>
                    </div>
                    <div class="flex-disp-between" style="gap:5px;">
                    <div class="flex-disp-between">
                    <app-button *ngIf="(isVariantActive() && promptUserDetails?.status == 'PUBLISHED') " class="icon-image" [type]="'secondary-noborder'" [buttonType]="'button'" [buttonText]="''" 
                        [iconSrc]="'/assets/icons/copy-text.svg'" (onClick)="editVersion('variant',promptUserDetails?.variant)" title="Duplicate"></app-button>
                    <app-button *ngIf="(promptUserDetails?.created_by?.created_by == userid && promptUserDetails?.status == 'PUBLISHED')" class="icon-image" [type]="'secondary-noborder'" [buttonType]="'button'" [buttonText]="''" 
                        [iconSrc]="'/assets/icons/edit-pen.svg'" (onClick)="editVersion('version')" title="Edit"></app-button>
                    </div>
                    <app-button [type]="'primary'" [buttonType]="'button'" [buttonText]="'Open'" 
                        [iconSrc]="''" (onClick)="openPrompt($event)"></app-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

@if(isLoading){
    <app-loader></app-loader>
    }